"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Heroorganisasipp() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: statementRef,
    isVisible: statementVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: indexRef,
    isVisible: indexVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const indexItems = [{
    label: "PROFIL",
    count: "01",
    href: "/ProfileConstitutionPage"
  }, {
    label: "WARTA",
    count: "12",
    href: "/NewsPage"
  }, {
    label: "LAYANAN",
    count: "05",
    href: "/ServicesPage"
  }];
  return;
}